import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { UserContext } from '../../context/User';
import { useLocation, useHistory } from "react-router-dom";
import { opportunitiesGet } from '../../api';
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import SinglePageItemText from '../SinglePageItemTypes/SinglePageItemText';
import SinglePageItemArray from '../SinglePageItemTypes/SinglePageItemArray';
import AlertMessage from '../AlertMessage';

const OPP_SINGLE_ALERT = `
  <div>
    <p class="mb-0">
      For complete information on this Contract Opportunity, please click on "applicable link" at bottom of this screen.
    </p>
  </div>
`;

const OpportunitySingle = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const sol_no = query.get("id");
  const [oppData, setoppData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  useEffect(() => {
    if (sol_no) {
      setLoading(true);
      opportunitiesGet({sol_no})
        .then(response => {
          setoppData(response.data);
          setLoading(false);
        })
        .catch(error => {
          handleDefaultStatusCodes(error.response.status);
          setLoading(false);
        })
    }
  }, []);

  const isClosed = () => {
    localStorage.setItem('opportunityAlertMessage', JSON.stringify({wasClosed: true}))
  }

  const wasClosed = () => {
    return !!JSON.parse(localStorage.getItem('opportunityAlertMessage'));
  }

  return (
    <section className="section-spaces">
       <Container>
        <Row>
          <Col>
            {
              !wasClosed() && <AlertMessage 
                alertMessage={OPP_SINGLE_ALERT}
                spaces="mt-0 mb-5 d-flex align-items-center"
                isClosed={isClosed}
              />
            }
            <div className="single-page-wrap">
              <h3>{oppData.title}</h3>
              <SinglePageItemText 
                title="Primary Point of Contact"
                value={oppData.contacts && oppData.contacts[0].fullname + ", " + oppData.contacts[0].email}
              />
              <SinglePageItemText 
                title="Secondary Point of Contact"
                value={oppData.contacts && oppData.contacts.slice(1).map(item => item.fullname + ", " + item.email).join(', ')}
              />
              <SinglePageItemText 
                title="Product Service Code"
                value={oppData.class_code}
              />
              <SinglePageItemText 
                title="Description"
                value={<div dangerouslySetInnerHTML={{ __html:oppData.description }} />}
              />
               <SinglePageItemText 
                title="NAICS Code"
                value={oppData.naics}
              />
              <SinglePageItemText 
                title="Notice ID"
                value={oppData.sol_no}
              />
              <SinglePageItemText 
                title="Published Date"
                value={oppData.posted_date}
              />
              <SinglePageItemText 
                title="Date Offers Due"
                value={oppData.deadline}
              />
              <SinglePageItemText 
                title="Inactive Date"
                value={oppData.archive_date}
              />
              <SinglePageItemText
                title="Place of Performance"
                value={[oppData.pop_address?.city_name, oppData.pop_address?.state_code, oppData.pop_address?.pop_zip, oppData.pop_address?.country_code].filter(item => item).join(", ")}
              />
              <SinglePageItemText 
                title="Set-Aside"
                value={oppData.setaside_code}
              />
              <div className="single-page-item align-items-center">
                <h4>
                 Aplicable Link
                </h4>
                <a className="btnSizes filledBtn" target="_blank" rel="noreferrer" href={oppData.sam_link}>View Opportunity</a>
              </div>
            </div>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default OpportunitySingle;
  